import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  code: {
    "& .hljs-string": {
      color: "#667a3a",
    },
    "& .hljs-name": {
      color: "#af4d26",
    },
    "& .hljs-attr": {
      color: "#af4d26",
    },
  },
}));

export default useStyles;
